import React from 'react';
import { TSearchBarConfig } from '../../../types/THeaderConfig';

const HeaderSearchBarContext = React.createContext<TSearchBarConfig | null>(null);

export default HeaderSearchBarContext;
